import React from "react";
import { Modal } from "react-bootstrap";

class ConfirmModal extends React.Component {
  state = {
    show: false,
  };

  handleClose = () => {
    this.setState({ show: false });
  };
  handleShow = (e) => {
    if (this.props.onShow) {
      this.props.onShow(e);
    }
    this.setState({ show: true });
    // if (window.CHASE) {
    //   window.CHASE.analytics.trackModalLoad(
    //     "cf-example-modal",
    //     `cf-${this.props.modalId}s-modal`
    //   );
    // }
  };
  iconHelper = () => {
    let iconHTML = "";
    if (this.props.iconClass) {
      iconHTML = <i className={this.props.iconClass} aria-hidden="true"></i>;
    }
    return iconHTML;
  };
  actionsHelper = () => {
    if (this.props.action) {
      return (
        <Modal.Footer>
          <button
            onClick={this.props.action}
            className="chaseanalytics-track-link btn btn-primary"
            // data-pt-name={`${this.props.dataptname}_ok`}
          >
            OK
          </button>
          <button
            onClick={this.handleClose}
            className="chaseanalytics-track-link btn btn-secondary"
            // data-pt-name={`${this.props.dataptname}_close`}
          >
            Close
          </button>
        </Modal.Footer>
      );
    } else {
      return (
        <Modal.Footer>
          <button
            onClick={this.handleClose}
            className="chaseanalytics-track-link btn btn-secondary"
            // data-pt-name={`${this.props.dataptname}_close`}
          >
            OK
          </button>
        </Modal.Footer>
      );
    }
  };
  render() {
    return (
      <>
        <button
          type="button"
          onClick={this.handleShow}
          className={this.props.buttonClass}
          // So data-pt-name={this.props.dataptname}
        >
          {this.iconHelper()}
          <br />
          {this.props.label}
        </button>

        <Modal size="lg" show={this.state.show} className={`${this.props.modalId}-modal avatar-modal`} onHide={this.handleClose}>
          <Modal.Header>
            <Modal.Title as="h3">{this.props.title}</Modal.Title>
            <button
              type="button"
              className="close"
              // data-pt-name={`${this.props.dataptname}_x-button`}
              onClick={this.handleClose}
            >
              <span aria-hidden="true">×</span>
              <span className="sr-only">Close</span>
            </button>
          </Modal.Header>
          <Modal.Body>
            <div>{this.props.question}</div>
          </Modal.Body>
          {this.actionsHelper()}
        </Modal>
      </>
    );
  }
}

export default ConfirmModal;
